import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/action_creators';
import { post_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import CommonHeader from '../../../util_components/common_header';

class TranscriptionSubmit extends Component {
  state = {
    raw_input: '',
    loading: false,
    results: []
  };

  submit_jobs = () => {
    const { raw_input } = this.state;
    const session_uuids = raw_input
      .split(/[\s,]+/)
      .map((s) => s.trim())
      .filter(Boolean);

    if (session_uuids.length === 0) {
      this.props.set_notification_variable(true, 'error', 'Please enter at least one session UUID.');
      return;
    }

    this.setState({ loading: true, results: [] });
    const url = get_api_url('/v2/transcription/jobs', false, true);

    post_api(url, { session_uuids }, true)
      .then((resp) => {
        const results = resp?.data?.results || [];
        this.setState({ loading: false, results });
        this.props.set_notification_variable(true, 'success', 'Jobs submitted successfully.');
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || 'Failed to submit transcription jobs.';
        this.setState({ loading: false });
        this.props.set_notification_variable(true, 'error', msg);
      });
  };

  render_results_table = () => {
    const { results } = this.state;
    if (results.length === 0) return null;
    return (
      <div style={{ marginTop: '24px', overflowX: 'auto' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#f1f5f9' }}>
              {['Session UUID', 'Status', 'Message'].map((h) => (
                <th
                  key={h}
                  style={{
                    padding: '8px 12px',
                    textAlign: 'left',
                    fontWeight: 600,
                    borderBottom: '2px solid #e2e8f0',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {results.map((row, i) => (
              <tr key={row.session_uuid || i} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9', fontFamily: 'monospace', fontSize: '12px' }}>
                  {row.session_uuid}
                </td>
                <td
                  style={{
                    padding: '7px 12px',
                    borderBottom: '1px solid #f1f5f9',
                    fontWeight: 600,
                    color: row.status === 'queued' ? '#16a34a' : row.status === 'error' ? '#dc2626' : '#334155'
                  }}
                >
                  {row.status}
                </td>
                <td style={{ padding: '7px 12px', borderBottom: '1px solid #f1f5f9', color: '#475569' }}>
                  {row.message || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    const { raw_input, loading } = this.state;
    return (
      <CommonHeader title="Submit Transcription Jobs" loading={loading}>
        <div style={{ maxWidth: '760px', padding: '24px 0' }}>
          <p style={{ marginBottom: '8px', fontSize: '13px', color: '#475569' }}>
            Paste session UUIDs separated by commas or newlines.
          </p>
          <textarea
            value={raw_input}
            onChange={(e) => this.setState({ raw_input: e.target.value })}
            rows={8}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontFamily: 'monospace',
              fontSize: '13px',
              border: '1px solid #cbd5e1',
              borderRadius: '6px',
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
            placeholder="uuid-1, uuid-2&#10;uuid-3"
            disabled={loading}
          />
          <button
            onClick={this.submit_jobs}
            disabled={loading || !raw_input.trim()}
            style={{
              marginTop: '12px',
              padding: '8px 20px',
              background: loading || !raw_input.trim() ? '#e2e8f0' : '#2563eb',
              color: loading || !raw_input.trim() ? '#94a3b8' : '#fff',
              border: 'none',
              borderRadius: '6px',
              fontWeight: 600,
              fontSize: '13px',
              cursor: loading || !raw_input.trim() ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Submitting...' : 'Submit Jobs'}
          </button>
          {this.render_results_table()}
        </div>
      </CommonHeader>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  set_notification_variable: (show, type, msg) =>
    dispatch(actions.set_notification_variable(show, type, msg))
});

export default connect(null, mapDispatchToProps)(TranscriptionSubmit);
